import { isObject } from '@iconik-io/core/src/is_object';
import type { SearchCriteriaRangeFilterSchema } from '@iconik-io/iconik-api/src/services/search';

import type { FilterValue } from '../../redux/common_filters/types';

export function guardFilterRange(
  filterValue: FilterValue,
): SearchCriteriaRangeFilterSchema | undefined {
  if (!Array.isArray(filterValue) && isObject(filterValue)) {
    return filterValue;
  }
  return undefined;
}
